export class WordMO {
	word: string;
	exclude: boolean;

	constructor(word: string = '', exclude: boolean = false) {
		this.word = word;
		this.exclude = exclude;
	}
}
